<app-history-list [list]="guestItem.notes" (onEdit)="onEdit($event)" [conentKey]="'note'" [userNameKey]="'user'"
                    [tableType]="tableType" [timeKey]="'timestamp'" [defaultUserImage]="'../assets/images/guest-demo-pic.jpg'"
                    [defaultIcon]="'fal tab-icon fa-clipboard-list'"></app-history-list>
